import { ELECTRON_EVENTS } from '~/main/namespace';

import type { AnyAction, Dispatch, Middleware } from '@reduxjs/toolkit';
import type { AppState } from '~/renderer/store/types';

export const forwardToMain: Middleware<AnyAction, AppState> =
  () => (next: Dispatch) => (action: AnyAction) => {
    if (action?.meta?.scope === 'local') return next(action);

    // stop action in-flight
    window.ipcRenderer?.send(ELECTRON_EVENTS.REDUX_ACTION, action);
    return undefined;
  };
